var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComputer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 15,
    viewBox: "0 0 21 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5817 12.644C13.3758 13.1735 13.0288 13.5264 12.6347 13.5264H7.65818C7.25818 13.5264 6.917 13.1735 6.71112 12.644H0.164062V13.6735C0.194169 14.0507 0.371442 14.4009 0.657599 14.6486C0.943755 14.8962 1.31583 15.0214 1.69347 14.997H18.6347C19.0123 15.0214 19.3844 14.8962 19.6705 14.6486C19.9567 14.4009 20.134 14.0507 20.1641 13.6735V12.644H13.5817Z",
    fill: "#111111"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.69347 3.23234H16.6347V11.4676H18.3994V1.80292C18.4041 1.56365 18.314 1.33223 18.1486 1.15919C17.9833 0.986151 17.7562 0.885564 17.517 0.879395H2.81112C2.57188 0.885564 2.3448 0.986151 2.17948 1.15919C2.01416 1.33223 1.92403 1.56365 1.92877 1.80292V11.4676H3.69347V3.23234Z",
    fill: "#111111"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComputer);
export default __webpack_public_path__ + "static/media/computer.21665a0564f4d0c1ad68ff5071c78f28.svg";
export { ForwardRef as ReactComponent };